import React, { useContext, useEffect, useState } from 'react'
import { Grid, Typography, useMediaQuery } from '@mui/material';
import IconsColor from '../../../utility/iconsColor';
import { UserContext, UserContextPayload } from '../../../../context/userContext';
import { useSearchParams } from 'react-router-dom';
import agent from '../../../../services/api';
import { MetaContext, MetaContextPayload } from '../../../../context/metaContext';
import { chatbotIntegrationAssignmentDataNew, createMetaIntegrationPayloadNew, DataItem, fbLoginResponse, getInstagramAccessTokenResponse, globalIntegration, instagramAccountDetailResponse, metaIntegrationFaceBookDataNew, metaIntegrationWhatsAppDataNew, metIntegrationInstagramDataNew } from '../../../../models/axiosModel';
import { checkForErrorCode, INSTAGRAM_LOGIN_SCOPE, isAgentOrAdmin, isOrganizationRoleAgent } from '../../../../utils/constants';
import { ChatbotContext, ChatbotContextPayload } from '../../../../context/chatbotContext';
import GlobalPopUp from '../../../utility/globalPopUp';
import GlobalDeletePopup from '../../../utility/globalDeletePopup/globalDeletePopup';
import instagramIcon from "../../../../assets/images/channels/instagram/instagram.png";
import GlobalButton from '../../../utility/globalButton/button';
import { IntegrationContext, IntegrationContextPayload } from '../../../../context/integrationContext';
import integrationStyles from '../../../../assets/styles/componentStyles/chatbotStyles/integrations.module.scss'
import FacebookInformationCard from '../../../utility/facebookInformationCard';
import ShowAvailableInstagramPages from './showAvailableInstagramPages';
import ChatbotInstagramIntegrationSetup from '../integrations/chatbotInstagramIntegrationSetup';
import globalStyles from "../../../../assets/styles/global.module.scss";
import { GenericDataContext, GenericDataContextPayload } from '../../../../context/genericDataContext';
import { AIChatbotBreadcrumb, chatbotDetailsBreadcrumb, homeBreadcrumb } from '../../../../utils/breadcrumb';
import { useShallow } from 'zustand/react/shallow';
import { useGenericStore } from '../../../../store/genericStore';
import { useIntegrationStore } from '../../../../store/integrationStore';

declare global {
    interface Window {
        fbAsyncInit: () => void;
        FB: any;
    }
}

interface addChatbotIntegrationDetailsInterface {
    chatbot_id: string,
    integrated_channel_id: string
}

interface responsePayloadInterface {
    page_id: string,
    page_name: string,
    page_category: string,
    access_token_value: string,
    instagram_id?: string,
    instagram_username?: string,
} 


const ChatbotInstagramIntegration = () => {
    const smallScreen = useMediaQuery('(max-width : 900px) and (min-width : 0px)')
    const mediaScreen = useMediaQuery('(max-width : 1200px) and (min-width : 0px)')
    const [flagFacebookIntegrationExist, setflagFacebookIntegrationExist] = useState<boolean | null>(null)
    const [searchParams] = useSearchParams();
    const chatbot_id = searchParams.get('chatbot_id');
    let pathname = window.location.pathname.toLowerCase();

    const { setFlagLoading, handleError, userDetail } = useContext(UserContext) as UserContextPayload;
    const { GetChatbotIntegrationData, getChatbotIntegrationData, setGetChatbotIntegrationData, metaCredentials, GetMetaCredentials } = useContext(MetaContext) as MetaContextPayload;
    const { setShowIntegrationDetails } = useContext(MetaContext) as MetaContextPayload;
    const { chatBotDetails } = useContext(ChatbotContext) as ChatbotContextPayload;
    const { getMetaIntegrationList, globalIntegrationTypeList, integrationListNewStructure, setIntegrationListNewStructure } = useContext(IntegrationContext) as IntegrationContextPayload;
    const { setBreadCrumbs } = useContext(GenericDataContext) as GenericDataContextPayload;

    const { showSuccess } = useGenericStore(useShallow((state) => ({
        showSuccess: state.showSuccess
    })))

    const { setFlagIntegrationNotAvailablePopup } = useIntegrationStore((useShallow((state) => ({
        setFlagIntegrationNotAvailablePopup: state.setFlagIntegrationNotAvailablePopup
    }))))

    const [showDeleteConfirmation, setShowDeleteConfirmation] = useState<boolean>(false);
    const [phoneNumberIntegrate, setPhoneNumberIntegrate] = useState<string>("")
    // const [linkedPagesData, setLinkedPagesData] = useState<linkedPageData[]>([])
    const [linkedPagesData, setLinkedPagesData] = useState<(metaIntegrationWhatsAppDataNew | metaIntegrationFaceBookDataNew | metIntegrationInstagramDataNew)[]>([])
    const [flagShowAvailablePages, setFlagShowAvailablePages] = useState<boolean>(false)
    // const [availablePagesData, setAvailablePagesData] = useState<globalIntegration[]>([])
    const [availablePagesData, setAvailablePagesData] = useState<(metaIntegrationWhatsAppDataNew | metaIntegrationFaceBookDataNew | metIntegrationInstagramDataNew)[]>([])
    const [flagShowpopup, setFlagShowpopup] = useState<boolean>(false)
    const [addChatbotIntegrationDetails, setAddChatbotIntegrationDetails] = useState<addChatbotIntegrationDetailsInterface>({
        chatbot_id: "",
        integrated_channel_id: ""
    })
    const [removeChatbotIntegrationDetails, setRemoveChatbotIntegrationDetails] = useState<addChatbotIntegrationDetailsInterface>({
        chatbot_id: "",
        integrated_channel_id: ""
    })
    const [responsePayload, setResponsePayload] = useState<responsePayloadInterface>({
        page_id: '',
        page_name: '',
        page_category: '',
        access_token_value: ''
    })

    async function getmetaIntegrations() {
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: true }))
        const response = await getMetaIntegrationList(true)
        if(!(response.status)){
            handleError(response);
        }
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: false }))
    }

    useEffect(() => {
        getmetaIntegrations()
    }, [])

    useEffect(() => {
        let ids: any = []
        if (integrationListNewStructure !== null && integrationListNewStructure.length > 0) {
            let facebookFilter = integrationListNewStructure?.filter((integration: metaIntegrationWhatsAppDataNew | metaIntegrationFaceBookDataNew | metIntegrationInstagramDataNew) => integration.channel_name.toLowerCase() == "instagram");
            facebookFilter?.map((data: metaIntegrationWhatsAppDataNew | metaIntegrationFaceBookDataNew | metIntegrationInstagramDataNew) => {
                if ("chatbot_integration_assignment_data" in data) {
                    data?.chatbot_integration_assignment_data.map((assignmentData: chatbotIntegrationAssignmentDataNew) => {
                        ids.push(String(assignmentData.chatbot_id ?? assignmentData.ai_chatbot_id))
                    })
                }
            })
            setAvailablePagesData(facebookFilter)
            let validID = ids.includes(chatBotDetails?.chatbot_id);

            if (validID && facebookFilter.length > 0 && integrationListNewStructure.filter((integration: metaIntegrationWhatsAppDataNew | metaIntegrationFaceBookDataNew | metIntegrationInstagramDataNew) => integration.channel_name.toLowerCase() == 'instagram').length > 0) {
                let linkedPhoneNumber: (metaIntegrationWhatsAppDataNew | metaIntegrationFaceBookDataNew | metIntegrationInstagramDataNew)[] = facebookFilter.filter((facebookPages: metaIntegrationWhatsAppDataNew | metaIntegrationFaceBookDataNew | metIntegrationInstagramDataNew) => {
                    if ("chatbot_integration_assignment_data" in facebookPages) {
                        return facebookPages?.chatbot_integration_assignment_data.some((chatbot) => (chatbot?.chatbot_id ?? chatbot?.ai_chatbot_id)?.toString() == searchParams.get('chatbot_id'))
                    }
                }
                )
                setLinkedPagesData(linkedPhoneNumber)
                setflagFacebookIntegrationExist(true)
                setShowIntegrationDetails(true)
            } else {
                setflagFacebookIntegrationExist(false)
                setShowIntegrationDetails(false)
            }
        } else {
            setflagFacebookIntegrationExist(false)
            setShowIntegrationDetails(false)
        }

    }, [getChatbotIntegrationData, chatBotDetails, window.location.href, integrationListNewStructure])

    useEffect(() => {
        const updatedBreadcrumbs = [
            {...homeBreadcrumb}, 
            AIChatbotBreadcrumb, 
            {...chatbotDetailsBreadcrumb, name: chatBotDetails?.chatbot_name ? chatBotDetails?.chatbot_name : "Chatbot", path: `/chatbot/viewchatbot/basicdetail?chatbot_id=${chatbot_id}`}, 
            { name: "Instagram Integration", path: `${pathname}?chatbot_id=${chatbot_id}` , isActive: true}
        ]; 
        setBreadCrumbs(updatedBreadcrumbs);
    }, [chatBotDetails])

    // useEffect(() => {
    //     if (integrationListNewStructure) {
    //         let temp: (metaIntegrationWhatsAppDataNew | metaIntegrationFaceBookDataNew | metIntegrationInstagramDataNew)[] = integrationListNewStructure.filter((data: metaIntegrationWhatsAppDataNew | metaIntegrationFaceBookDataNew | metIntegrationInstagramDataNew) => data.channel_name.toLowerCase() === "instagram")
    //         if (temp) {
    //             let linkedPhoneNumber: (metaIntegrationWhatsAppDataNew | metaIntegrationFaceBookDataNew | metIntegrationInstagramDataNew)[] = temp.filter((phoneNumber: metaIntegrationWhatsAppDataNew | metaIntegrationFaceBookDataNew | metIntegrationInstagramDataNew) => "chatbot_integration_assignment_data" in phoneNumber && phoneNumber?.chatbot_integration_assignment_data.some((chatbot) => chatbot.chatbot_id.toString() == searchParams.get('chatbot_id')))
    //             if (temp) {
    //                 if (linkedPhoneNumber) {
    //                     setLinkedPagesData(linkedPhoneNumber)
    //                 }
    //                 setAvailablePagesData(integrationListNewStructure)
    //             }
    //         }
    //     }
    //     // }, [integrationList])
    // }, [integrationListNewStructure])

    const [codeValue, setCodeValue] = useState({
        code: ""
    })
    const [whatsappData, setWhatsappData] = useState({
        waba_id: "",
        phone_number_id: ""
    })

    useEffect(() => {
        if (userDetail.flagUser && !isOrganizationRoleAgent(userDetail) && !isAgentOrAdmin(userDetail)) {
            if (!metaCredentials) {
                GetMetaCredentials();
            }
        }
    }, [metaCredentials, userDetail])

    useEffect(() => {
        if (metaCredentials) {
            (function (d, s, id) {
                let js, fjs = d.getElementsByTagName(s)[0];
                if (d.getElementById(id)) return;
                js = d.createElement(s) as HTMLScriptElement;
                js.id = id;
                js.src = "https://connect.facebook.net/en_US/sdk.js";
                fjs.parentNode!.insertBefore(js, fjs);
            }(document, 'script', 'facebook-jssdk'));
        
            let facebookConfig = metaCredentials.find((configuration) => configuration.channel_name.toLowerCase() == "instagram")
            window.fbAsyncInit = function () {
                // @ts-ignore
                FB.init(facebookConfig.fb_init);
            };
        }
    }, [metaCredentials]);
    useEffect(() => {
        const sessionInfoListener = (event: MessageEvent) => {
            if (event.origin !== "https://www.facebook.com") return;
            try {
                const data = JSON.parse(event.data);
                // Handle the data from the event
                // console.log("session info data", data);


                if (data.type === 'WA_EMBEDDED_SIGNUP') {
                    // if user finishes the Embedded Signup flow
                    if (data.event === 'FINISH') {
                        const { phone_number_id, waba_id } = data.data;
                        setWhatsappData({ ...whatsappData, phone_number_id: phone_number_id, waba_id: waba_id })
                    }
                    // if user cancels the Embedded Signup flow
                    else {
                        const { current_step } = data.data;
                    }
                }
            } catch (error) {
                // Handle errors or non-JSON messages
            }
        };
        window.addEventListener('message', sessionInfoListener);

        // Cleanup listener on component unmount
        return () => {
            window.removeEventListener('message', sessionInfoListener);
        };
    }, []);
    useEffect(() => {
        (async () => {
            if (responsePayload && responsePayload.page_id !== "" && !flagShowpopup && responsePayload.instagram_id && responsePayload.instagram_id != "" && responsePayload.instagram_username && responsePayload.instagram_username != "") {
                let metaIntegrationTypeId = globalIntegrationTypeList.find((type) => type.channel_name.toLowerCase() === "instagram")?.channel_id ?? Number(process.env.REACT_APP_FACEBOOK_META_INTEGRATION_TYPE_ID);

                if (!metaIntegrationTypeId) {
                    console.error("Meta Integration Type ID for Facebook is undefined");
                    return;
                }

                const facebookPayload: createMetaIntegrationPayloadNew = {
                    channel_id: metaIntegrationTypeId,
                    meta_integration_instagram_data: [{
                        instagram_account_id: responsePayload.instagram_id,
                        instagram_account_name: responsePayload.instagram_username,
                        instagram_account_category: responsePayload?.page_category,
                        access_token_value: responsePayload?.access_token_value,
                    }],
                    channel_authoriser_user_data: {
                        authoriser_unique_id: Number(responsePayload?.page_id),
                        authoriser_unique_name: responsePayload?.page_name,
                        authoriser_unique_email: "",
                    },
                    meta_data: JSON.stringify(responsePayload)
                };


                const response = await agent.createMetaIntegration.post(facebookPayload);
                if (response.status) {
                    showSuccess("Integration Successfull!")
                    let chatbot_id = searchParams.get('chatbot_id')
                    let responseNewStructure = response.data[0]
                    let whatsappIntegrations = responseNewStructure.meta_integration_whatsapp_data.map((integration: any) => {
                        return {
                            ...integration,
                            integrated_channel_id: integration.meta_integration_whatsapp_id,
                            channel_name: 'Whatsapp'
                        }
                    })
                    setIntegrationListNewStructure([...whatsappIntegrations, ...responseNewStructure.meta_integration_facebook_data, ...responseNewStructure.meta_integration_instagram_data
                    ])
                    let sortedData = responseNewStructure.meta_integration_facebook_data.sort((a: globalIntegration, b: globalIntegration) => new Date(b.created_at_timestamp).getTime() - new Date(a.created_at_timestamp).getTime())
                    let data = sortedData[0]
                    if (chatbot_id) {
                        let payload = {
                            chatbot_id: chatbot_id,
                            integrated_channel_id: data.integrated_channel_id,
                        }
                        AddChatbotIntegration(payload)
                    }
                }
                else {
                    let errorCode = checkForErrorCode(response)
                    if (response.message == "canceled") {
                    }
                    else {
                        handleError(response);
                    }
                    safeLogout()
                }
            }
        })();
    }, [responsePayload]);

    const safeLogout = (): void => {
        // Check the user's current login status
        window.FB.getLoginStatus((response: any) => {
            if (response.status === 'connected') {
                // User is logged in to your app and Facebook.
                // It's safe to call logout
                window.FB.logout((logoutResponse: any) => {
                    // Handle post-logout logic here
                });
            } else {
                console.log('User was not logged in via Facebook SDK. No need to log out.');
                // Handle scenarios where the user was not logged in
            }
        });
    };

    function fetchInstagramAccountDetails(igAccountId: string, pageData: responsePayloadInterface) {
        window.FB.api(`/${igAccountId}?fields=id,username,biography,followers_count,follows_count,profile_picture_url,website`, function (igAccountInfo: instagramAccountDetailResponse) {
            let payloadfinal = { ...pageData }
            payloadfinal.instagram_username = igAccountInfo.username
            payloadfinal.instagram_id = igAccountId
            setResponsePayload(payloadfinal)
        })
    }

    function getInstagramAccessToken() {
        window.FB.api("/me/accounts?fields=access_token,category,category_list,name,id,tasks,instagram_business_account", function (result: getInstagramAccessTokenResponse) {
            if (result && !result.error) {
                const pages: DataItem[] = result.data
                // for (let i = 0; i < pages.length; i++) {

                for (let i = 0; i < 1; i++) {
                    const page = pages[i]
                    // window.FB.api(`/${page.id}?fields=instagram_business_account`, function (pageInfo: any) {
                    //     console.log("pageInfo---", pageInfo)
                    let pageData = {
                        page_id: page.id,
                        page_name: page.name,
                        page_category: page.category,
                        access_token_value: page.access_token,
                    }
                    if (page.instagram_business_account) {
                        const igAccountId = page.instagram_business_account.id
                        // Fetch Instagram account details using igAccountId
                        fetchInstagramAccountDetails(igAccountId, pageData)
                    } else {
                        console.log(`No Instagram Business Account linked to page ${page.name}`)
                    }
                    // })
                }
            } else {
                console.log("Error fetching Instagram account access token:", result.error)
            }
        })
    }

    function loginToInstagram() {

        let instagramConfig = metaCredentials?.find((configuration) => configuration.channel_name.toLowerCase() == "instagram")

        if(!instagramConfig?.flag_can_integrate){
            setFlagIntegrationNotAvailablePopup(true);
            return;
        }

        window.FB.login(
            function (response: any) {
                console.log("res: ", response)
                if (response.authResponse) {
                    console.log("Welcome! Fetching your information....")
                    window.FB.api("/me", function (res: fbLoginResponse) {
                        console.log("res 1:", res)
                        console.log("Good to see you, " + res.name + ".")
                        getInstagramAccessToken()
                    })
                } else {
                    console.log("User cancelled login or did not fully authorize.")
                }
            },
            { scope: INSTAGRAM_LOGIN_SCOPE }
        )
    }
    const deleteChatbotIntegration = async () => {
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: true }));
        let channel_id = globalIntegrationTypeList?.find((channel) => channel?.channel_name?.toLowerCase() == 'instagram')?.channel_id.toString() || ''
        const response = await agent.removeChatbotIntegration.delete(
            channel_id,
            removeChatbotIntegrationDetails.chatbot_id,
            removeChatbotIntegrationDetails.integrated_channel_id
        );
        if (response.status) {
            // await GetChatbotIntegrationData(removeChatbotIntegrationDetails.chatbot_id, "")
            await getmetaIntegrations()
            showSuccess("Integration Removed Successfully")
            // getmetaIntegrations()
        } else {
            handleError(response);
        }
        setShowDeleteConfirmation(false)
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: false }));
    }


    const handleRemoveChatbotIntegration = (instagram_username: string, integrated_channel_id: string) => {
        if (integrationListNewStructure) {
            let chatbot_id = searchParams.get('chatbot_id')
            if (chatbot_id) {
                setRemoveChatbotIntegrationDetails(
                    {
                        chatbot_id: chatbot_id,
                        integrated_channel_id: integrated_channel_id
                    }
                )
            }
            setShowDeleteConfirmation(true)
            setPhoneNumberIntegrate(instagram_username)
        }
    }

    function addChatbotIntegration(integrated_channel_id: string, instagram_username: string, event?: React.MouseEvent<HTMLButtonElement>) {
        if (event) {
            handleClick(event)
        }
        let chatbot_id = searchParams.get('chatbot_id')
        if (chatbot_id) {
            setAddChatbotIntegrationDetails((prevState) => ({
                ...prevState,
                chatbot_id: chatbot_id,
                integrated_channel_id: integrated_channel_id.toString()
            }))
        }
        setPhoneNumberIntegrate(instagram_username)
    }
    async function AddChatbotIntegration(addChatbotIntegrationDetails: addChatbotIntegrationDetailsInterface) {
        handleCloseConfirmationPopover()
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: true }))
        let payload = {
            chatbot_id: addChatbotIntegrationDetails.chatbot_id,
            integrated_channel_id: addChatbotIntegrationDetails.integrated_channel_id
        }
        const response = await agent.addChatbotIntegration.post(payload)
        if (response.status) {
            // setGetChatbotIntegrationData(response.data)
            await getmetaIntegrations()
            showSuccess("Integration Successfull!")
            setFlagShowpopup(true)
        } else {
            handleError(response);
        }
        setFlagShowAvailablePages(false)
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: false }))
    }
    const [showConfirmationPopover, setShowConfirmationPopover] = React.useState(false);

    const [confirmationPopoverAnchorEl, setConfirmationPopoverAnchorEl] = React.useState<HTMLButtonElement | null>(null);
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setConfirmationPopoverAnchorEl(event.currentTarget);
        setShowConfirmationPopover(true)
    };

    const handleCloseConfirmationPopover = () => {
        setConfirmationPopoverAnchorEl(null);
        setShowConfirmationPopover(false)
    };

    return (
        <>
            {flagShowAvailablePages &&
                <ShowAvailableInstagramPages
                    flagShowAvailableNumbers={flagShowAvailablePages}
                    setFlagShowAvailableNumbers={setFlagShowAvailablePages}
                    smallScreen={smallScreen}
                    showConfirmationPopover={showConfirmationPopover}
                    confirmationPopoverAnchorEl={confirmationPopoverAnchorEl}
                    handleCloseConfirmationPopover={handleCloseConfirmationPopover}
                    addChatbotIntegrationDetails={addChatbotIntegrationDetails}
                    AddChatbotIntegration={AddChatbotIntegration}
                    availablePhoneNumberData={availablePagesData}
                    handleRemoveChatbotIntegration={handleRemoveChatbotIntegration}
                    displayPhoneNumber={phoneNumberIntegrate}
                    launchWhatsAppSignup={loginToInstagram}
                    saveChatbotIntegrationData={addChatbotIntegration}
                />

            }
            {flagFacebookIntegrationExist == false ?
                <>
                    <Grid container className={`${globalStyles.flexColumn} ${globalStyles.startAlignmentStyle} ${globalStyles.containerFlexWrap} ${globalStyles.fullwidth} `}gap={2}  pt={1}>
                    <Grid item className={globalStyles.fullwidth}>
                            <Grid container className={`${globalStyles.createChatbotContainer} ${globalStyles.containerFlexWrap}`}  gap={"13px"} mt={mediaScreen ? 2 : 1} >
                                <Grid item className={globalStyles.displayFlexStyle}>
                                    <img alt="" src={instagramIcon} className={integrationStyles.whatsappIntegrationIcon} />
                                </Grid>
                                <Grid item>
                                    <Typography className={integrationStyles.whatsappIntegrationFontStyle}>Integrate with your Instagram Account</Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item className={globalStyles.wpIntegrationWrapper}>
                            {
                                integrationListNewStructure && integrationListNewStructure?.filter((integration: metaIntegrationWhatsAppDataNew | metaIntegrationFaceBookDataNew | metIntegrationInstagramDataNew) => integration.channel_name === "Instagram").length > 0 ?
                                    <>
                                        <Grid container className={globalStyles.flexColumn}>
                                            <Grid item>
                                                <span className={globalStyles.textWpInt}>This Chatbot is not linked with any Instagram Account yet. </span>
                                            </Grid>
                                            <Grid item className={globalStyles.padTop}>
                                                <GlobalButton buttonText={"Add Instagram Account"} className='primaryButtonStyle' onClick={() => { setFlagShowAvailablePages(true) }} sx={{ padding: "6px 20px !important" }} startIcon={<IconsColor fillColor="#FFFFFF" iconName="plus" width="15px" height="15px" />} />
                                            </Grid>
                                        </Grid>
                                    </>
                                    :
                                    <Grid container className={globalStyles.flexColumn}>
                                        <Grid item>
                                            <ChatbotInstagramIntegrationSetup launch={loginToInstagram} />
                                        </Grid>
                                        <Grid item sx={{ borderTop: "1px solid #E1DCDC", paddingTop: "20px" }}>
                                            <GlobalButton buttonText={"Integrate Instagram Account"} className='primaryButtonStyle' onClick={loginToInstagram} />
                                        </Grid>
                                    </Grid>
                            }

                        </Grid>
                    </Grid>
                </>
                :
                <>
                    {integrationListNewStructure &&
                        <Grid container className={`${globalStyles.flexColumn} ${globalStyles.gapLength} `} sx={{ padding: { xs: "15px 7px", lg: "15px 15px 15px 5px" } }} mt={{ xs: 1, lg: 0 }}>
                            <Grid item>
                                <Grid container className={globalStyles.gapLess}>
                                    {linkedPagesData.map((pageData: metaIntegrationWhatsAppDataNew | metaIntegrationFaceBookDataNew | metIntegrationInstagramDataNew, index) => (
                                        <FacebookInformationCard
                                            integrationType='Instagram'
                                            key={index}
                                            flagDelete={false}
                                            title={`WhatsApp Account ${index + 1}`}
                                            currentlySelected={true}
                                            showRemoveChatbotIntegration={true}
                                            removeChatbotIntegration={() => { handleRemoveChatbotIntegration("instagram_account_name" in pageData ? pageData.instagram_account_name : "", String(pageData.integrated_channel_id)) }}
                                            details={{
                                                page_id: "instagram_account_id" in pageData ? pageData.instagram_account_id : "",
                                                integrated_channel_id: String(pageData.integrated_channel_id),
                                                page_name: "instagram_account_name" in pageData ? pageData.instagram_account_name : "",
                                                page_category: "instagram_account_category" in pageData ? pageData.instagram_account_category : "",
                                                linked_chatbots: "chatbot_integration_assignment_data" in pageData ? pageData.chatbot_integration_assignment_data : undefined,
                                            }}
                                            flagIntegration={true}
                                        />
                                    ))}
                                </Grid>
                            </Grid>
                            <Grid item>

                                <GlobalButton onClick={() => { setFlagShowAvailablePages(true) }} buttonText={"Add Instagram Account"} className={'blackShadowedButton'}
                                    startIcon={<IconsColor fillColor="#A5A5A5" iconName="plus" width="19px" height="19px" />}
                                />
                            </Grid>

                        </Grid>}
                    {
                        showDeleteConfirmation &&
                        <GlobalDeletePopup
                            open={showDeleteConfirmation}
                            title={"Undeploy Chatbot Confirmation"}
                            deleteDescription={`Are you sure you want to undeploy ${chatBotDetails?.chatbot_name} from ${phoneNumberIntegrate}`}
                            onClose={() => { setShowDeleteConfirmation(false) }}
                            onDelete={deleteChatbotIntegration}
                            primaryButtonText={"Undeploy"}
                        />
                    }
                    {
                        flagShowpopup &&
                        <GlobalPopUp
                            open={flagShowpopup}
                            flagShowCloseIcon
                            backgroundColor={"#40813F"}
                            title={"Congratulations!"}
                            handleClose={() => { setFlagShowpopup(false) }}
                        >
                            <Grid container sx={{ padding: "30px 45px 30px" }} direction={"column"} gap="7px">
                                <Grid item sx={{ fontSize: "15px", fontWeight: "500" }}>
                                    The AI chatbot has been successfully deployed on this Instagram page!
                                </Grid>
                                <Grid item sx={{ fontSize: "15px", fontWeight: "500" }}> you can now head to your instagram account and start chatting with the instagram page.</Grid>
                                <Grid item sx={{ fontSize: "15px", fontWeight: "500" }}>You can also track your chats <a href={`/inbox`}>here</a> in the inbox</Grid>
                            </Grid>
                        </GlobalPopUp>
                    }
                </>
            }

        </>
    )
}

export default ChatbotInstagramIntegration;